import React from 'react';

const NotFoundPage = () => <p>Page not found</p>;

export default NotFoundPage;
